import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { MeasureService } from '../measure.service';
import { ModalMeasureReportConsultComponent } from '../modal-measure-report-consult/modal-measure-report-consult.component';
import { ModalMeasureReportComponent } from '../modal-measure-report/modal-measure-report.component';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';
import { ModalShareMeasureComponent } from '../modal-share-measure/modal-share-measure.component';
import { ModalCheckInformantComponent } from '../modal-check-informant/modal-check-informant.component';
import { ModalInformantComponent } from '../modal-informant/modal-informant.component';
import { ProfileService } from '../../profile/profile.service';

@Component({
  selector: 'app-measure-start',
  templateUrl: './measure-start.component.html',
  styleUrls: ['./measure-start.component.scss']
})
export class MeasureStartComponent implements OnInit {

  link: string;
  measure
  measureForm: FormGroup;
  // progressVal: number;
  countProgress: number = 0;
  measureButtonStatus: boolean = false;
  type: string = 'measure';
  isLoading: boolean = false;

  // params
  participant: number; // form mail --> don't show modal invite informant
  participant_from: string = '' // form mail
  isMultiInformant: number = 0; // form click in measure page --> show modal invite informant

  informantComplete: boolean = true;
  informant_type: number = 0;

  userEmail: string;

  constructor(
    private fb: FormBuilder,
    private measureService: MeasureService,
    private router: Router,
    public matDialog: MatDialog,
    private location: Location,
    private gobalFunctionService: GobalFunctionService,
    private profileService: ProfileService,
  ) { }

  ngOnInit(): void {
    this.participant = JSON.parse(new URL(location.href).searchParams.get('participant')); // from email
    this.participant_from = new URL(location.href).searchParams.get('participant_from'); // from email
    this.isMultiInformant = JSON.parse(new URL(location.href).searchParams.get('IS_MULTI_INFORMANT')); // from click

    console.log(this.participant);
    console.log(this.participant_from);
    this.isLoading = true;
    if (this.measureService.accessLink) {
      this.measureService.DetailMeasureStart(this.participant_from).pipe(
        map(res => {
          if (res.success) {
            this.isLoading = false;
            this.measure = res.result[0];
            this.gobalFunctionService.setTitle(this.measure.MEASURE_NAME);

            if (this.isMultiInformant === 1) {
              this.getParticipant(this.measure.MEASURE_ID);
            }
            // // console.log(this.measure);

          } else if (res.result[0].IS_VIEW === 1) {
            this.isLoading = false;
            alert('ไม่สามารถเข้าถึงแบบทดสอบนี้ได้');
            this.router.navigate(['/']);
            return of(null);
          }
        }),
        catchError((err) => {
          this.isLoading = false;
          alert(err.error.message);
          return of(null);
        })
      ).subscribe();
    } else {
      this.location.back();
    }


    this.measureForm = this.fb.group({
      DATA: this.fb.array([]),
    });

    this.getProfile();

  }

  getProfile() {
    this.profileService.getProfile().pipe(
      map(email => {
        if (email.success) {
          this.userEmail = email.result.EMAIL;
        }
      })
    ).subscribe();
  }

  getParticipant(measureID) {
    this.measureService.getParticipantByMeasure(measureID).pipe(
      map(res => {
        if (res.success) {
          for (let i = 0; i < res.result.length; i++) {
            let el = res.result[i];
            if (el.COMPLETED === 0) {
              this.informantComplete = false;
              break;
            }
          }
        }
      })
    ).subscribe();
  }

  mStatus() {
    // // console.log(this.measureForm);
    if (this.measureForm.value.DATA.length === this.measure.details.length) {
      this.measureButtonStatus = true;
    }
  }

  progress(e) {
    // // console.log(e);
    let p = e;
    if (e === 2) {
      p = p - 1;
      this.countProgress += (p / this.measureForm.value.DATA.length) * 100;
    } else if (e === 0) {
      p = p + 1;
      // // console.log(p);
      // // console.log(e);
      this.countProgress -= (p / this.measureForm.value.DATA.length) * 100;
    }
    // // console.log(this.countProgress);
  }

  send(form) {
    // // console.log(form);
    let body = {
      MEASURE_ID: this.measure.MEASURE_ID,
      INFORMANT_TYPE: 0,
      PARTICIPANT_FROM: null,
      DATA: []
    }

    form.value.DATA.forEach(e => {
      // // console.log(e);
      body.DATA.push({
        ID: e.ID,
        ANSWER: JSON.stringify(e.ANSWER)
      })
    });
    this.isLoading = true;
    this.measureService.takeMeasureByUser(body).pipe(
      switchMap(res => {
        if (res.success) {
          this.isLoading = false;
          // // console.log(res);

          if (res.result.report_data.length > 0) {
            if (res.result.report_data[0].TEMPLATE_FREE_TYPE || res.result.report_data[0].TEMPLATE_NOTFREE_TYPE) {
              const dialogConfig = new MatDialogConfig();
              dialogConfig.disableClose = true;
              dialogConfig.id = 'modalMeasureReport';
              dialogConfig.width = '600px';
              dialogConfig.autoFocus = false;
              dialogConfig.data = {
                title: 'รายงานผล',
                report: res.result.report_data,
                view_status: 1,
                ROLE: res.result.ROLE,
              }

              const reportModal = this.matDialog.open(ModalMeasureReportComponent, dialogConfig);

              const dialogConfig2 = new MatDialogConfig();
              this.isLoading = true;
              return reportModal.afterClosed().pipe(
                switchMap(m => {
                  if (m.status) {
                    this.isLoading = false;
                    dialogConfig2.disableClose = true;
                    dialogConfig2.id = 'modalConfirm';
                    dialogConfig2.width = '500px';
                    dialogConfig2.autoFocus = false;
                    let graph = m.report_type;
                    // // console.log(m);

                    const confirmModal = this.matDialog.open(ModalMeasureReportConsultComponent, dialogConfig2);
                    return confirmModal.afterClosed().pipe(
                      map(r => {
                        window.open(`/test-report?type=${graph}&paid=${m.paid}&mid=${this.measure.MEASURE_ID}&view_status=${m.view_status}&informant_type=0`, '_blank');
                        this.router.navigate(['/']);
                      })
                    )
                  } else {
                    this.isLoading = false;
                    return of(null);
                  }
                })
              )

            } else {
              const dialogConfig3 = new MatDialogConfig();
              dialogConfig3.disableClose = true;
              dialogConfig3.id = 'modalConfirm';
              dialogConfig3.width = '350px';
              dialogConfig3.data = {
                title: 'ส่งแบบทดสอบ',
                description: `<img src="../../../assets/congratulation.png" width="100px;" class="img-center">
                <h5>ส่งแบบทดสอบแล้ว</h5>
                <h6>แบบทดสอบนี้ยังไม่มีรายงานผล</h6>
                <h6>ขอบคุณที่เข้าร่วมทำแบบทดสอบ</h6>`,
                cancleBtnText: 'ยืนยัน',
                customStyle: 'background-color: #58595B;'
              }

              const modal = this.matDialog.open(ModalComponent, dialogConfig3);
              return modal.afterClosed().pipe(
                map(res => {
                  if (!res) {
                    // // console.log(res);
                    this.router.navigate(['/']);
                    // window.close();
                  }
                })
              )
            }

          } else {

            const dialogConfig3 = new MatDialogConfig();
            dialogConfig3.disableClose = true;
            dialogConfig3.id = 'modalConfirm';
            dialogConfig3.width = '350px';
            dialogConfig3.data = {
              title: 'ส่งแบบทดสอบ',
              description: `<img src="../../../assets/congratulation.png" width="100px;" class="img-center">
              <h5>ส่งแบบทดสอบแล้ว</h5>
              <h6>แบบทดสอบนี้ยังไม่มีรายงานผล</h6>
              <h6>ขอบคุณที่เข้าร่วมทำแบบทดสอบ</h6>`,
              cancleBtnText: 'ยืนยัน',
              customStyle: 'background-color: #58595B;'
            }

            const modal = this.matDialog.open(ModalComponent, dialogConfig3);
            return modal.afterClosed().pipe(
              map(res => {
                if (!res) {
                  // // console.log(res);
                  // window.close();
                  this.router.navigate(['/']);
                }
              })
            )

          }
        }
      }),
      catchError((err) => {
        this.isLoading = false;
        alert(err.error.message);
        this.router.navigate(['/']);
        return of(null)
      })
    ).subscribe();

    // // console.log(body);
  }

  sendByInformant(form) {
    let body = {
      MEASURE_ID: this.measure.MEASURE_ID,
      INFORMANT_TYPE: this.participant ? this.participant : 0,
      PARTICIPANT_FROM: this.participant_from,
      DATA: []
    }

    form.value.DATA.forEach(e => {
      // // console.log(e);
      body.DATA.push({
        ID: e.ID,
        ANSWER: JSON.stringify(e.ANSWER)
      })
    });

    console.log(body);

    if (this.participant === 1 && this.participant_from) {
      this.takeByInformant(body);
    } else {
      this.takeByTarget(body);
    }
  }

  takeByTarget(body) {
    this.measureService.takeMeasureByUser(body).pipe(
      switchMap(tk => {
        if (tk.success) {
          if (!this.informantComplete) {
            const informantDialogConflig = new MatDialogConfig();
            informantDialogConflig.disableClose = true;
            informantDialogConflig.id = 'modalConfirm';
            informantDialogConflig.width = '450px';

            const informantModal = this.matDialog.open(ModalCheckInformantComponent, informantDialogConflig);
            return informantModal.afterClosed().pipe(
              switchMap(ifm => {
                if (ifm.status) {
                  const dialogInformantConfig = new MatDialogConfig();
                  dialogInformantConfig.disableClose = true;
                  dialogInformantConfig.id = 'modalInformantMeasure';
                  dialogInformantConfig.width = '650px';
                  dialogInformantConfig.autoFocus = false;
                  dialogInformantConfig.panelClass = 'full-width-dialog';
                  dialogInformantConfig.data = {
                    MEASURE_ID: this.measure.MEASURE_ID,
                    userEmail: this.userEmail,
                  }
                  const informantModal = this.matDialog.open(ModalInformantComponent, dialogInformantConfig);
                  return informantModal.afterClosed().pipe(
                    switchMap(res => {
                      if (res.status) {
                        if (res.type === 'change') {

                          return this.measureService.inviteInformantMeasure(res.body).pipe(
                            switchMap(res => {
                              if (res.success) {

                                const successDialogConfig = new MatDialogConfig();
                                successDialogConfig.disableClose = true;
                                successDialogConfig.id = 'modalConfirm';
                                successDialogConfig.width = '350px';
                                successDialogConfig.data = {
                                  title: 'ผู้ที่มีส่วนร่วมในการทำแบบทดสอบ',
                                  description: `<img src="../../../assets/check.png" width="100px;" class="img-center">
                                      <h5>ส่งคำเชิญสำเร็จ</h5>`,
                                  cancleBtnText: 'ยืนยัน',
                                  customStyle: 'background-color: #58595B;'
                                }

                                const modal = this.matDialog.open(ModalComponent, successDialogConfig);
                                return modal.afterClosed().pipe(
                                  map(close => {
                                    if (!close) {
                                      // // console.log(res);
                                      this.router.navigate(['/']);
                                      // window.close();
                                    }
                                  })
                                );
                              } else {
                                this.router.navigate(['/']);
                                return of(false);
                              }
                            })
                          )
                        } else if (res.type === 'report') {
                          return of(null);
                        }
                      } else {
                        this.router.navigate(['/']);
                        return of(null);
                      }
                    }),
                    catchError(error => {
                      alert('ระบบขัดข้อง กรุณาลองใหม่อีกครั้ง')
                      return of(false);
                    })
                  )
                } else {
                  this.router.navigate(['/']);
                  return of(null);
                }
              })
            )

          } else {
            this.isLoading = false;
            // // console.log(res);

            if (tk.result.report_data.length > 0) {
              if (tk.result.report_data[0].TEMPLATE_FREE_TYPE || tk.result.report_data[0].TEMPLATE_NOTFREE_TYPE) {
                const dialogConfig = new MatDialogConfig();
                dialogConfig.disableClose = true;
                dialogConfig.id = 'modalMeasureReport';
                dialogConfig.width = '600px';
                dialogConfig.autoFocus = false;
                dialogConfig.data = {
                  title: 'รายงานผล',
                  report: tk.result.report_data,
                  view_status: 1,
                  ROLE: tk.result.ROLE,
                }

                const reportModal = this.matDialog.open(ModalMeasureReportComponent, dialogConfig);

                const dialogConfig2 = new MatDialogConfig();
                this.isLoading = true;
                return reportModal.afterClosed().pipe(
                  switchMap(m => {
                    if (m.status) {
                      this.isLoading = false;
                      dialogConfig2.disableClose = true;
                      dialogConfig2.id = 'modalConfirm';
                      dialogConfig2.width = '500px';
                      dialogConfig2.autoFocus = false;
                      let graph = m.report_type;
                      // // console.log(m);

                      const confirmModal = this.matDialog.open(ModalMeasureReportConsultComponent, dialogConfig2);
                      return confirmModal.afterClosed().pipe(
                        map(r => {
                          window.open('/test-report?type=' + graph + '&paid=' + m.paid + '&mid=' + this.measure.MEASURE_ID + '&view_status=' + m.view_status + '&informant_type=0', '_blank');
                          // // console.log(r);
                          // window.close();
                          this.router.navigate(['/']);
                        })
                      )
                    } else {
                      this.isLoading = false;
                      return of(null);
                    }
                  })
                )

              } else {
                const dialogConfig3 = new MatDialogConfig();
                dialogConfig3.disableClose = true;
                dialogConfig3.id = 'modalConfirm';
                dialogConfig3.width = '350px';
                dialogConfig3.data = {
                  title: 'ส่งแบบทดสอบ',
                  description: `<img src="../../../assets/congratulation.png" width="100px;" class="img-center">
                  <h5>ส่งแบบทดสอบแล้ว</h5>
                  <h6>แบบทดสอบนี้ยังไม่มีรายงานผล</h6>
                  <h6>ขอบคุณที่เข้าร่วมทำแบบทดสอบ</h6>`,
                  cancleBtnText: 'ยืนยัน',
                  customStyle: 'background-color: #58595B;'
                }

                const modal = this.matDialog.open(ModalComponent, dialogConfig3);
                return modal.afterClosed().pipe(
                  map(res => {
                    if (!res) {
                      // // console.log(res);
                      this.router.navigate(['/']);
                      // window.close();
                    }
                  })
                )
              }

            } else {

              const dialogConfig3 = new MatDialogConfig();
              dialogConfig3.disableClose = true;
              dialogConfig3.id = 'modalConfirm';
              dialogConfig3.width = '350px';
              dialogConfig3.data = {
                title: 'ส่งแบบทดสอบ',
                description: `<img src="../../../assets/congratulation.png" width="100px;" class="img-center">
                <h5>ส่งแบบทดสอบแล้ว</h5>
                <h6>แบบทดสอบนี้ยังไม่มีรายงานผล</h6>
                <h6>ขอบคุณที่เข้าร่วมทำแบบทดสอบ</h6>`,
                cancleBtnText: 'ยืนยัน',
                customStyle: 'background-color: #58595B;'
              }

              const modal = this.matDialog.open(ModalComponent, dialogConfig3);
              return modal.afterClosed().pipe(
                map(res => {
                  if (!res) {
                    // // console.log(res);
                    // window.close();
                    this.router.navigate(['/']);
                  }
                })
              )

            }
          }
        }
      }),
      catchError(er => {
        alert('ระบบขัดข้อง กรุณาลองใหม่อีกครั้ง');
        return of(false);
      })
    ).subscribe();
  }

  takeByInformant(body) {

    const haveNotReportDialogConfig = new MatDialogConfig();
    haveNotReportDialogConfig.disableClose = true;
    haveNotReportDialogConfig.id = 'modalConfirm';
    haveNotReportDialogConfig.width = '350px';
    haveNotReportDialogConfig.data = {
      title: 'ส่งแบบทดสอบ',
      description: `<img src="../../../assets/congratulation.png" width="100px;" class="img-center">
      <h5>ส่งแบบทดสอบแล้ว</h5>
      <h6>แบบทดสอบนี้ยังไม่มีรายงานผล</h6>
      <h6>ขอบคุณที่เข้าร่วมทำแบบทดสอบ</h6>`,
      cancleBtnText: 'ยืนยัน',
      customStyle: 'background-color: #58595B;'
    }

    this.measureService.takeMeasureByUser(body).pipe(
      switchMap(res => {
        if (res.success) {

          if (res.result.report_data.length > 0) {
            if (res.result.report_data[0].TEMPLATE_FREE_TYPE) {
              const haveReportDialogConfig = new MatDialogConfig();
              haveReportDialogConfig.disableClose = true;
              haveReportDialogConfig.id = 'modalConfirm';
              haveReportDialogConfig.width = '350px';
              haveReportDialogConfig.data = {
                title: 'ส่งแบบทดสอบ',
                description: `<img src="../../../assets/congratulation.png" width="100px;" class="img-center">
                <h5>ส่งแบบทดสอบแล้ว</h5>
                <h6>ขอบคุณที่เข้าร่วมทำแบบทดสอบ</h6>`,
                cancleBtnText: 'เปิดรายงานผล',
                customStyle: 'background-color: #58595B;'
              }

              const modal = this.matDialog.open(ModalComponent, haveReportDialogConfig);
              return modal.afterClosed().pipe(
                map(md => {
                  if (!md) {
                    // // console.log(res);
                    window.open(`/test-report?type=${res.result.report_data[0].TEMPLATE_FREE_TYPE}&paid=free&mid=${res.result.report_data[0].MEASURE_ID}&view_status=1&informant_type=1`, '_blank');
                    this.router.navigate(['/']);
                    // window.close();
                  }
                })
              )
            } else {
              const modal = this.matDialog.open(ModalComponent, haveNotReportDialogConfig);
              return modal.afterClosed().pipe(
                map(res => {
                  if (!res) {
                    // // console.log(res);
                    this.router.navigate(['/']);
                    // window.close();
                  }
                })
              )
            }
          } else {
            const modal = this.matDialog.open(ModalComponent, haveNotReportDialogConfig);
            return modal.afterClosed().pipe(
              map(res => {
                if (!res) {
                  // // console.log(res);
                  this.router.navigate(['/']);
                  // window.close();
                }
              })
            )
          }

        }
      }),
      catchError(err => {
        alert('ระบบขัดข้อง กรุณาลองใหม่อีกครั้ง');
        return of(false);
      })
    ).subscribe();
  }

}
